/**
 * SDZ Drop — storefront motion (Wave D1)
 * Scroll reveals + hero class hooks. Pulse apparel must not load this file.
 */
(function () {
  if (typeof document === "undefined") return;

  const reduce =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.documentElement.classList.add("sdz-drop-root");

  function markRevealTargets() {
    const selectors = [
      ".card",
      ".product-card",
      ".card-wrapper",
      ".multicolumn-card",
      ".section-header",
      ".collection__title",
      ".newsletter",
      ".image-with-text",
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        if (!el.classList.contains("sdz-drop-reveal")) {
          el.classList.add("sdz-drop-reveal");
        }
      });
    });
  }

  function observeReveals() {
    if (reduce) {
      document.querySelectorAll(".sdz-drop-reveal").forEach((el) => {
        el.classList.add("sdz-drop-inview");
      });
      return;
    }
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(".sdz-drop-reveal").forEach((el) => {
        el.classList.add("sdz-drop-inview");
      });
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("sdz-drop-inview");
          io.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.12 },
    );
    document.querySelectorAll(".sdz-drop-reveal").forEach((el) => io.observe(el));
  }

  function boot() {
    markRevealTargets();
    observeReveals();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
